import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';
import { FiltersFormCertificatesAnpr } from './list/types';

export const initialValuesCertificateAnpr: FiltersFormCertificatesAnpr = {
  alias: '',
  startValidityDate: null,
  endValidityDate: null,
  code: '',
  page: 0,
  rowsPerPage: 10,
  orders: {},
};

const PageCertificateAnprsInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesCertificateAnpr}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageCertificateAnprsInitializer.displayName = 'Page Certificate Anpr initializer component';

export default PageCertificateAnprsInitializer;
